import { request } from '../request'

// 获取升级记录
export const getUpgradeRecord = (params: { page: number; limit: number }) =>
  request('/portal/systemManager/serverUpgrade/records', {
    method: 'GET',
    params,
  })

// 获取记录日志
export const getUpgradeLog = (id: string) =>
  request(`/portal/systemManager/serverUpgrade/records/${id}/log`, {
    method: 'GET',
  })

// 通知升级
export const notifyUpgrade = (id: string) =>
  request(`/portal/systemManager/serverUpgrade/upgrade/${id}`, {
    method: 'POST',
    data: {},
    timeout: 120000,
  })

// 修改上传状态
export const updateUploadStatus = (id: string, data: { status: number }) =>
  request(`/portal/systemManager/serverUpgrade/upload/${id}/status`, {
    method: 'PUT',
    data,
  })

// 获取升级包详情
export const getUpgradePackage = (id: string) =>
  request(`/portal/systemManager/serverUpgrade/records/${id}/package`, {
    method: 'GET',
  })

// 获取当前版本信息
export const getCurrentVersion = () =>
  request('/portal/systemManager/serverUpgrade/current', {
    method: 'GET',
  })

// 获取记录
export const getRecord = id =>
  request(`/portal/systemManager/serverUpgrade/record/${id}`, {
    method: 'GET',
  })

// 创建上传记录
export const createUploadRecord = () =>
  request('/portal/systemManager/serverUpgrade/records', {
    method: 'POST',
    data: {},
  })

// 获取当前状态
export const getCurrentStatus = () =>
  request('/portal/systemManager/serverUpgrade/current/status', {
    method: 'GET',
  })
